export default "__VITE_ASSET__C$0Y7aIo__"